module.exports = __webpack_public_path__ + "static/media/lv.1e3c2988.svg";